<template>
  
  <Intro :onModalOpen="onModalOpen" />

  <ArtificialIntelligence />

  <MarketsPosition />

  <Crosswork />

  <Flags :onModalOpen="onModalOpen" />

  <MarketPositionScreens />

  <CompetitionComparison />

  <Outro :onModalOpen="onModalOpen" />

  <ContactInvestorModal ref="investorContact" />

  <ContactGeneralModal ref="generalContact" />

</template>

<script>

import Intro from "../components/investment/Intro";
import ArtificialIntelligence from "../components/investment/ArtificialIntelligence";
import MarketsPosition from "../components/investment/MarketsPosition";
import Crosswork from "../components/investment/Crosswork";
import Flags from "../components/investment/Flags";
import MarketPositionScreens from "../components/investment/MarketPositionScreens";
import CompetitionComparison from "../components/investment/CompetitionComparison";
import Outro from "../components/investment/Outro";

import ContactGeneralModal from "../components/investment/ContactGeneralModal";
import ContactInvestorModal from "../components/investment/ContactInvestorModal";

export default {
  components: { 
    Intro, 
    ArtificialIntelligence, 
    MarketsPosition, 
    Crosswork, 
    Flags, 
    MarketPositionScreens, 
    CompetitionComparison, 
    Outro, 
    ContactGeneralModal, 
    ContactInvestorModal 
  }, 
  methods: {
    onModalOpen(type) {
      if (type == 'investor') {
        this.$refs.investorContact.open();
      } else {
        this.$refs.generalContact.open();
      }
    }
  }
}
</script>